import { z } from 'zod';
import { createZodFormResolver } from '@mews/framework';
import { AssignPropertiesFieldNames, AssignPropertiesSegment } from '../types';

export const assignPropertiesSchema = z.discriminatedUnion('segment', [
    z.object({
        segment: z.literal(AssignPropertiesSegment.PropertyGroups),
        [AssignPropertiesFieldNames.PropertyGroups]: z.array(z.string()).min(1).default([]),
    }),
    z.object({
        segment: z.literal(AssignPropertiesSegment.Properties),
        [AssignPropertiesFieldNames.Properties]: z.array(z.string()).min(1).default([]),
    }),
]);

export type AssignPropertiesFormValues = z.infer<typeof assignPropertiesSchema>;

export const toAssignPropertiesParameters = (values: AssignPropertiesFormValues) => ({
    propertyGroupIds: values.segment === AssignPropertiesSegment.PropertyGroups ? values.propertyGroups : null,
    propertyIds: values.segment === AssignPropertiesSegment.Properties ? values.properties : null,
});

export const assignPropertiesResolver = createZodFormResolver(assignPropertiesSchema);

export const assignPropertiesDefaultValues = {
    [AssignPropertiesFieldNames.Segment]: AssignPropertiesSegment.PropertyGroups,
    [AssignPropertiesFieldNames.PropertyGroups]: [],
};
